import { useSyncExternalStore } from "react";

// Minimal shared open/closed state for the Quantfolio call-log rail, so a jump
// triggered from anywhere (e.g. the investor view) can pop the rail open while
// the toggle lives in the app shell.
let open = false;
const listeners = new Set<() => void>();
function emit() {
  for (const l of listeners) l();
}

export const qpRail = {
  isOpen: () => open,
  open() {
    if (!open) {
      open = true;
      emit();
    }
  },
  close() {
    if (open) {
      open = false;
      emit();
    }
  },
  toggle() {
    open = !open;
    emit();
  },
  subscribe(l: () => void) {
    listeners.add(l);
    return () => listeners.delete(l);
  },
};

export function useQpRailOpen(): boolean {
  return useSyncExternalStore(
    (l) => qpRail.subscribe(l),
    () => open,
    () => open,
  );
}
